import React from 'react'

const SvgPipeFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14 6v2h1a2 2 0 012 2v6a2 2 0 01-2 2H9a2 2 0 01-2-2v-6a2 2 0 012-2h1V6h4zM3 9a1 1 0 011 1v1h2v4H4v1a1 1 0 11-2 0v-6a1 1 0 011-1zm18 0a1 1 0 011 1v6a1 1 0 11-2 0v-1h-2v-4h2v-1a1 1 0 011-1zm-6-5a1 1 0 110 2H9a1 1 0 010-2h6z'
    />
  </svg>
)

export default SvgPipeFilled
